import React from 'react'

export function getI18nText(microcopy, id) {
  try {
    if (
      process.env.GATSBY_SHOW_I18N_ID !== undefined &&
      process.env.GATSBY_SHOW_I18N_ID !== null &&
      process.env.GATSBY_SHOW_I18N_ID === 'true'
    ) {
      return (
        <abbr style={{ textDecoration: 'none' }} title={id}>
          {microcopy[id].value}
        </abbr>
      )
    } else {
      return microcopy[id].value
    }
  } catch (error) {
    return id
  }
}

export function getI18nTextWithFallback(microcopy, id, fallback) {
  let text = getI18nText(microcopy, id)

  if (text === '' || (text === id && fallback)) {
    text = fallback
  }

  return text
}

export function getI18nTextWithFallbackId(microcopy, id, fallbackId) {
  let text = getI18nText(microcopy, id)

  if (text === '' || (text === id && fallbackId)) {
    const fallbackText = getI18nText(microcopy, fallbackId)

    if (fallbackText && fallbackText !== '' && fallbackText !== fallbackId) {
      text = fallbackText
    }
  }

  return text
}

export function convertToMicrocopyKey(value) {
  if (value) {
    value = formatSpecificMicrocopyKeys(value)
    value = value.replace(/ /g, '')
    value = value.replace(/\//g, '')
    value = value.replace(/"/g, '')
    value = value.replace(/-/g, '')
    value = value.replace(/_/g, '')
    value = value.replace(/\(/g, '')
    value = value.replace(/\)/g, '')
    value = value.replace(/,/g, '')
    value = value.replace(/µ/g, '')
    value = value.replace(/⌀/g, '')
    value = value.replace(/°/g, '')
    value = value.replace(/'/g, '')
    value = value.replace(/\+/g, '')
    value = value.replace(/\//g, '')
    value = value.replace(/,/g, '')
    value = value.replace(/&/g, '')
    // value = value.replace(/\./g, '')
    value = value.toLowerCase()
  }
  return value
}

function formatSpecificMicrocopyKeys(value) {
  if (value) {
    switch (value) {
      case '1/4"':
        value = value.concat('inch')
        break
      case '1/2"':
        value = value.concat('inch')
        break

      default:
        break
    }
  }
  return value
}

export function getI18nTextWithVars(microcopy, id, vars) {
  try {
    let text = microcopy[id].value
    for (const [key, value] of Object.entries(vars)) {
      text = text.split(`{{${key}}}`).join(value)
    }
    if (
      process.env.GATSBY_SHOW_I18N_ID !== undefined &&
      process.env.GATSBY_SHOW_I18N_ID !== null &&
      process.env.GATSBY_SHOW_I18N_ID === 'true'
    ) {
      return (
        <abbr style={{ textDecoration: 'none' }} title={id}>
          {text}
        </abbr>
      )
    }
    return text
  } catch (error) {
    return id
  }
}

export function doesMicrocopyTextExist(microcopy, id) {
  if (microcopy[id] !== null && microcopy[id] !== undefined) {
    return true
  } else {
    return false
  }
}
